export enum DateCardOrderStatus {
    delivered = 'delivered',
    default = '',
    addressIssue = 'address-issue',
    nickname = 'nickname',
    cardIntro = 'card-intro',
    fullname = 'fullname',
    other = 'other',
}